export interface GetPaginationRes<T> {
  itemsCount?: number;
  items: T[];
}

export function getPaginatedRes<T>(response: any, entityName: string): GetPaginationRes<T> {
  return { itemsCount: response.totalCount || response.itemsCount || response.count, items: response[entityName] || [] };
}

export interface PaginationEvent {
  pageSize: number;
  pageIndex: number;
}

export function getEmptyPaginatedRes<T>(): GetPaginationRes<T> {
  return { itemsCount: 0, items: [] };
}

export interface PaginationReq {
  page: number;
  limit: number;
}
